import styled from "styled-components";
import { COLORS, responsive, THEME } from "../../styles/constants.style";
import { fontWeightBold } from "../typography/MuiTypography.style";

export const MuiStepperWrapper = styled.div`
  margin-top: 30px;

  ${responsive.MOBILE`
    margin-top: 16px;
  `}

  .MuiStepConnector-root {
    left: calc(-38% + 20px);
    right: calc(66% + 20px);
    top: 21px;

    ${responsive.MOBILE`
      top: 16px;
    `}
  }

  .open-step {
    .MuiStepConnector-line {
      border-color: ${COLORS.cirrus_black4};
      border-top-width: 2px;
    }
  }

  .completed-step {
    .MuiStepConnector-line {
      border-color: ${COLORS.cirrus_green1};
      border-top-width: 2px;
    }
  }

  .status {
    border-radius: 50%;
    border: 4px solid ${COLORS.cirrus_black4};
    height: 48px;
    width: 48px;

    ${responsive.MOBILE`
      height: 32px;
      width: 32px;
      font-size: ${THEME.fontSizes[400]};
      border: 3px solid ${COLORS.cirrus_black4};
    `}
  }

  .status-queue {
    border-color: ${COLORS.cirrus_black8};
  }

  .status-completed {
    border: none;
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_green1};
    padding: 9px;
  }

  .status-inprogress {
    border: 4px solid ${COLORS.cirrus_green1};
    color: ${COLORS.cirrus_green1};
    padding: 7px;

    ${responsive.MOBILE`
      border: 3px solid ${COLORS.cirrus_green1};
      padding: 0 0 0 2px;
    `}

    svg {
      height: 19px;
      width: 19px;
      margin-left: 4px;

      ${responsive.MOBILE`
        height: 14px;
        width: 14px;
      `}
    }
  }

  .status-inprogress-processing {
    border: 4px solid ${COLORS.cirrus_orange_dark1};
    color: ${COLORS.cirrus_orange_dark1};
    padding: 1px;

    ${responsive.MOBILE`
      border-width: 3px;
    `}
  }

  .process-image {
    height: 40px;
    width: 40px;
    margin-right: 8px;
    ${responsive.MOBILE`
      height: 28px;
      width: 28px;
      margin-right: 0;
    `}
  }

  .status-open {
    padding: 3px 12px;
    color: ${COLORS.cirrus_black7};
    background-color: ${COLORS.cirrus_white};

    ${responsive.MOBILE`
      padding: 1px 8px;
    `}
  }

  .label-inprogress {
    ${fontWeightBold}
    color: ${COLORS.cirrus_black};
    ${responsive.MOBILE`
      font-size: ${THEME.fontSizes[400]};
    `}
  }
  .normal-label {
    color: ${COLORS.cirrus_black7};
    ${responsive.MOBILE`
      font-size: ${THEME.fontSizes[300]};
    `}
  }
`;
